import { Api } from '@/services/Api';

export default {
    /*  1. Get all data */
    getServiceDetailsByCriteria(body = { keyword: '' }) {
        return Api().post('/ServiceDetails/GetServiceDetailsByCriteria', body);
    },
    /*  2. Get one column */
    getServiceDetails(id) {
        return Api().get(`/ServiceDetails/${id}`);
    },
    /*  3. Create one column */
    saveServiceDetails(body) {
        return Api().post(`/ServiceDetails`, body);
    },
    /*  4. Delete one or more columns */
    deleteServiceDetails(serviceDetails) {
        return Api().post(`/ServiceDetails/DeleteServiceDetails`, serviceDetails);
    },
    /*  5. post one or more columns */
    postServiceDetails(serviceDetails) {
        return Api().post(`/ServiceDetails/PostServiceDetails`, serviceDetails);
    },
    startWF(body) {
        return Api().post(`/ServiceDetails/StartWF`, body);
    }
};
